// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import React, { useState } from "react";
import { subscribeToNewsletter } from "../../utils/newsletter";
import styles from "../../styles/authForm.module.scss";

function NewsletterFormComponent() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [status, setStatus] = useState(null);

    async function handleSubmit(event) {
        event.preventDefault();
        setLoading(true);
        setMessage(null);

        try {
            const data = await subscribeToNewsletter(email);

            // The API deliberately answers "pending" whether or not the
            // address was already on the list, so the copy here must not
            // imply either - that difference would leak list membership.
            if (data.status === "pending") {
                setStatus("success");
                setMessage("Almost there! Check your inbox for a confirmation link. 📬");
                setEmail("");
            } else {
                throw new Error("Unexpected response");
            }
        } catch {
            setStatus("error");
            setMessage("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    }

    return (
        <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
                <label className={styles.label} htmlFor="newsletter-email">
                    Email
                </label>
                <input
                    id="newsletter-email"
                    type="email"
                    className={styles.input}
                    placeholder="you@example.com"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                    required
                />
            </div>

            <button type="submit" className={styles.primaryButton} disabled={loading}>
                {loading ? "Sending..." : "Subscribe"}
            </button>

            {message && (
                <p
                    className={status === "error" ? styles.errorText : styles.successText}
                    role={status === "error" ? "alert" : "status"}
                >
                    {message}
                </p>
            )}

            <p className={styles.helperText}>No spam. Product updates only. Unsubscribe anytime.</p>
        </form>
    );
}

export default NewsletterFormComponent;
